module.exports = __webpack_public_path__ + "static/media/loading.1f90f2d2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = 310
// module chunks = 0